<div class="user-access-history">
    <breadcrumbs [path]="breadcrumbs"></breadcrumbs>
    <span class="page-header">{{localize(langSection.Breadcrumb, langText.UserAccessHistory)}}</span>
    <div class="d-flex flex-column">
        <h4>{{localize(langSection.UserAccessHistory, langText.UserInformation)}}</h4>
        <span class="preserve-white-space"><span class="fw-bold me-1">{{localize(langSection.UserAccessHistory, langText.UserId)}}:</span>{{userAccessHistory?.upsId || upsId}}</span>
        <span><span class="fw-bold me-1">{{localize(langSection.Term, langText.Email)}}:</span>{{userAccessHistory?.email || email}}</span>
    </div>
    <div class="search-container">
        <user-access-history-search [audits]="userAccessHistory?.audits" (filterAudits)="setFilteredList($event)"></user-access-history-search>
    </div>
    <div class="audit-container">
        @if (!userAccessHistory) {
<span class="entry-count">0 {{localize(langSection.UserAccessHistory, langText.Entries)}}</span>
}
        @if (filteredAudits?.length > 1 || filteredAudits?.length === 0) {
<span class="entry-count">{{filteredAudits?.length}} {{localize(langSection.UserAccessHistory, langText.Entries)}}</span>
}
        @if (filteredAudits?.length === 1) {
<span class="entry-count">{{filteredAudits?.length}} {{localize(langSection.UserAccessHistory, langText.Entry)}}</span>
}
        <div class="audit-grid-header">
            <span>{{localize(langSection.UserAccessHistory, langText.Date)}}</span>
            <span>{{localize(langSection.UserAccessHistory, langText.Time)}}</span>
            <span>{{localize(langSection.UserAccessHistory, langText.Location)}}</span>
            <span>{{localize(langSection.UserAccessHistory, langText.Role)}}</span>
            <span>{{localize(langSection.UserAccessHistory, langText.Activity)}}</span>
        </div>
        <virtual-scroller #scroll class="audit-grid-body" [items]="filteredAudits" [bufferAmount]="1">
            @for (audit of scroll.viewPortItems; track audit) {
<div class="audit-row">
                <span class="fw-bold">{{audit?.date | localizedDate:'M/D/yyyy':'yyyy/MM/DD'}}</span>
                <span class="audit-time">
                    <span class="fw-bold">{{audit?.date | localizedDate:'h:mm':'HH:mm'}} ({{localizeValue(langSection.TimeZones, dateService.getBrowserTimezoneAbbreviation())}})</span>
                </span>
                <span class="audit-slic-name">{{audit?.locationSlicName}}</span>
                <span class="audit-role">{{localize(langSection.Role, getRoleText(audit?.role))}}</span>
                <span class="audit-activity" title="{{localize(langSection.UserAccessActivity, getActivityText(audit?.activity)) | uppercase}} {{localize(langSection.Term, langText.By) | lowercase}} {{audit?.modifyingUser}}">
                    {{localize(langSection.UserAccessActivity, getActivityText(audit?.activity)) | uppercase}} {{localize(langSection.Term, langText.By) | lowercase}} {{audit?.modifyingUser}}
                </span>
                <span></span>
            </div>
}
        </virtual-scroller>
    </div>
    <button routerLink="/location-users" class="py-2 px-5 border-0 text-white bg-green me-4 round-button">{{localize(langSection.DatePicker, langText.Close)}}</button>
</div>